<template lang="pug">
.sms-code-verification
    digit-code-input(:digits="6" :is-invalid="isInvalid" @input="onCodeInput")
    .invalid-feedback(v-if="isInvalid")
        p {{$t(invalidCodeText)}}
    button.btn.btn-primary(:disabled="code.length !== 6 || validating" @click.prevent="validate") {{$t(confirmButtonText)}}
</template>
<script>
import DigitCodeInput from '@/components/common/DigitCodeInput.vue';

export default {
    name: 'SmsCodeVerification',

    components: { DigitCodeInput },

    props: {
        token: {
            type: String,
            required: true
        },

        invalidCodeText: {
            type: String,
            default: 'registration.pin.error'
        },

        confirmButtonText: {
            type: String,
            default: 'login.actions.submit'
        }
    },

    data() {
        return {
            code: '',
            isInvalid: false,
            validating: false
        };
    },

    methods: {
        onCodeInput(code) {
            this.code = code;
            this.isInvalid = false;
        },

        async validate() {
            this.validating = true;
            try {
                const data = await this.$services.account.validateInvitationToken({ token: this.token, code: this.code }, { phone: true });
                const url = `${window.APP.appRootUrl}/invitations/${this.$route.params.branding}?invitationToken=${data.token}`;
                this.$services.routing.redirect(url);
            } catch {
                // Don't rethrow: this endpoint's 401s would otherwise trip Vue's global errorHandler and blank the whole page instead of showing the inline error.
                this.isInvalid = true;
            } finally {
                this.validating = false;
            }
        }
    }
};
</script>
